/**
 * ニュースレター送信成功メッセージを一定時間後に非表示にする（画面に貼り付いたままに見えないようにする）
 */
(function () {
  var VISIBLE_MS = 5000;
  var FADE_MS = 450;

  function hideBanner(el) {
    if (!el || el.hasAttribute('hidden')) return;
    el.classList.add('newsletter-success-banner--hiding');
    window.setTimeout(function () {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
      el.style.display = 'none';
      el.classList.remove('newsletter-success-banner--hiding');
    }, FADE_MS);
  }

  function init() {
    var selectors =
      '.newsletter-form__success-banner, .newsletter-form .newsletter-form__message--success.form__message';
    document.querySelectorAll(selectors).forEach(function (el) {
      window.setTimeout(function () {
        hideBanner(el);
      }, VISIBLE_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
